export default __webpack_public_path__ + "media/images/about_us/kitchen-bb550755e97f622dec97e5e940e53ad7.png";